export default {
  rooms: 'Комнат:',
  area: 'Площадь:',
  ai_predictions_title: '📊 Прогнозные оценки стоимости AI',
  more: 'Подробнее +',

  // 🏷 Тип сделки
  purpose: {
    sale: 'Продажа',
    rent: 'Аренда',
    short_term: 'Краткосрочная аренда'
  }
}